<bit-card class="tw-size-full tw-flex tw-flex-col">
  <!-- Title Section with Badge -->
  <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
    <h2 bitTypography="h3" class="tw-m-0">{{ title() }}</h2>

    <!-- Status Badge -->
    <span bitBadge [variant]="badge().variant" class="tw-ml-3">
      {{ badge().text }}
    </span>
  </div>

  <!-- Cart Summary -->
  <billing-cart-summary [cart]="subscription().cart" [header]="cartSummaryHeader" />

  <!-- Status-Based Callout -->
  @if (callout(); as callout) {
    <bit-callout [type]="callout.type" [icon]="callout.icon" [title]="callout.title">
      <div class="tw-flex tw-flex-col tw-gap-2">
        <p class="tw-m-0">{{ callout.description }}</p>
        @if (callout.callsToAction) {
          <div class="tw-flex tw-flex-row tw-gap-2">
            @for (cta of callout.callsToAction; track cta.action) {
              <button
                bitButton
                [buttonType]="cta.buttonType"
                [endIcon]="cta.endIcon"
                (click)="callToActionClicked.emit(cta.action)"
                type="button"
              >
                {{ cta.text }}
              </button>
            }
          </div>
        }
      </div>
    </bit-callout>
  }

  <!-- Projected content slot for warnings (e.g., price-increase warning) -->
  <ng-content></ng-content>
</bit-card>

<ng-template #cartSummaryHeader let-amountDue="amountDue">
  <h2
    bitTypography="h5"
    class="!tw-m-0"
    id="cart-summary-header-custom"
    data-test-id="cart-summary-header-custom"
  >
    @let status = subscription().status;
    @switch (status) {
      @case ("incomplete") {
        {{ "yourSubscriptionWillBeSuspendedOn" | i18n }}
        <span class="tw-font-bold">{{ suspension() | date: dateFormat }}</span>
      }
      @case ("incomplete_expired") {
        {{ "yourSubscriptionWasSuspendedOn" | i18n }}
        <span class="tw-font-bold">{{ suspension() | date: dateFormat }}</span>
      }
      @case ("trialing") {
        @if (cancelAt(); as cancelAt) {
          {{ "yourSubscriptionWillBeCanceledOn" | i18n }}
          <span class="tw-font-bold">{{ cancelAt | date: dateFormat }}</span>
        } @else {
          {{ "yourNextChargeIsFor" | i18n }}
          <span class="tw-font-bold">{{ amountDue | currency: "USD" : "symbol" }} USD</span>
          {{ "dueOn" | i18n }}
          <span class="tw-font-bold">{{ nextCharge() | date: dateFormat }}</span>
        }
      }
      @case ("active") {
        @if (cancelAt(); as cancelAt) {
          {{ "yourSubscriptionWillBeCanceledOn" | i18n }}
          <span class="tw-font-bold">{{ cancelAt | date: dateFormat }}</span>
        } @else {
          {{ "yourNextChargeIsFor" | i18n }}
          <span class="tw-font-bold">{{ amountDue | currency: "USD" : "symbol" }} USD</span>
          {{ "dueOn" | i18n }}
          <span class="tw-font-bold">{{ nextCharge() | date: dateFormat }}</span>
        }
      }
      @case ("past_due") {
        @if (suspension(); as suspension) {
          {{ "yourSubscriptionWillBeSuspendedOn" | i18n }}
          <span class="tw-font-bold">{{ suspension | date: dateFormat }}</span>
        } @else {
          {{ "subscriptionPastDueWillPauseSoon" | i18n }}
        }
      }
      @case ("canceled") {
        {{ "yourSubscriptionWasCanceledOn" | i18n }}
        <span class="tw-font-bold">{{ canceled() | date: dateFormat }}</span>
      }
      @case ("unpaid") {
        @if (suspension(); as suspension) {
          {{ "yourSubscriptionWasSuspendedOn" | i18n }}
          <span class="tw-font-bold">{{ suspension | date: dateFormat }}</span>
        } @else {
          {{ "subscriptionPastDuePaused" | i18n }}
        }
      }
    }
  </h2>
</ng-template>
